import { Injectable } from "@angular/core";
import type { TourId } from "./tours.types";
import { TOURS } from "./tours.registry";
import { TourEngineService } from "./tour-engine.service";
import { TOURS_CONFIG } from "./tours.config";
import { UsuariosService } from "../services/usuarios.service";
import { lastValueFrom } from "rxjs";
import { k } from "src/environments/properties";

@Injectable({ providedIn: "root" })
export class HelpToursService {
  constructor(
    private engine: TourEngineService,
    private usuarioService: UsuariosService,
  ) {}

  setTourEnabled(enabled: boolean): void {
    TOURS_CONFIG.enabled = enabled;
  }

  async start(id: TourId, force = false) {
    // Configuración global
    if (!TOURS_CONFIG.enabled) {
      return;
    }

    const canShow = await this.canShowTours();

    if (!canShow) {
      return;
    }

    const def = TOURS[id];
    if (!def) {
      console.warn(`[Tours] No existe definición para: ${id}`);
      return;
    }
    return this.engine.start(def, { force });
  }

  stop() {
    this.engine.stop();
  }

  async canShowTours(): Promise<boolean> {
   

    const userId = localStorage.getItem(k.user_id);

    if (!userId) {
      return false;
    }

    const response = await lastValueFrom(
      this.usuarioService.getUsuario(userId),
    );

    return response?.body?.accesoGuiado === true;
  }
}
